export const dev = process.env.REACT_APP_NODE_ENV === 'development';

interface IApi {
    publications: string;
    users: string;
    autoRed: string;
    pns: string;
    transactions: string;
    bikleta: string;
    notifications: string;
    payments: string;
    offers: string;
    credits: string;
    settings: string;
    inspections: string;
    openai: string;
    records: string;
    omuni: string;
    reports: string;
    leads: string;
    citroen: string;
    citroenLogin: string;
    citroenModels: string;
    citroenVersions: string;
    citroenRegions: string;
    citroenComunes: string;
    citroenDealerships: string;
    citroenPrices: string;
    citroenContracts: string;
}

export const api: IApi = {
    publications: "publications",
    users: "users",
    autoRed: "vehicles",
    pns: process.env.REACT_APP_API_PNS || "",
    transactions: "transactions",
    bikleta: process.env.REACT_APP_API_BIKLETA || "",
    notifications: "notifications",
    offers: "publications",
    payments: "payments",
    credits: "credits",
    settings: "settings",
    inspections: "inspections",
    openai: "openai",
    omuni: "omuni",
    records: "records",
    reports: "reports",
    leads: "leads",
    citroen:  process.env.REACT_APP_API_CITROEN || "",
    citroenLogin:  process.env.REACT_APP_API_CITROEN_LOGIN || "",
    citroenModels: process.env.REACT_APP_API_CITROEN_MODELS || "",
    citroenVersions: process.env.REACT_APP_API_CITROEN_VERSIONS || "",
    citroenRegions: process.env.REACT_APP_API_CITROEN_REGIONES || "",
    citroenComunes: process.env.REACT_APP_API_CITROEN_COMUNAS || "",
    citroenDealerships: process.env.REACT_APP_API_CITROEN_CONCESIONARIAS || "",
    citroenPrices: process.env.REACT_APP_API_CITROEN_PRICES || "",
    citroenContracts: process.env.REACT_APP_API_CITROEN_CONTRACT_PRICES || ""
}